var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.params.value)?_c('v-icon',{attrs:{"color":"error"}},[_vm._v(" mdi-close-circle ")]):_c('v-icon',{attrs:{"color":"success"}},[_vm._v(" mdi-check-circle ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }